import { render, staticRenderFns } from "./PlatformPosts.vue?vue&type=template&id=95905052&"
import script from "./PlatformPosts.vue?vue&type=script&lang=js&"
export * from "./PlatformPosts.vue?vue&type=script&lang=js&"
import style0 from "./PlatformPosts.vue?vue&type=style&index=0&id=95905052&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95905052')) {
      api.createRecord('95905052', component.options)
    } else {
      api.reload('95905052', component.options)
    }
    module.hot.accept("./PlatformPosts.vue?vue&type=template&id=95905052&", function () {
      api.rerender('95905052', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/campaign/EditCampaign/PlatformPosts.vue"
export default component.exports